<template>
	<div class="main_page error_page">
		<video autoplay muted loop style="" src="/static/images/bg/error_bg.mp4"></video>
		<div class="error_page_content">
			<p>Something</p>
			<p>went <span>wrong</span></p>
			<el-button round class="back_btn" @click="back_home">{{$t('contactUs.gohome')}}</el-button>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'Error',
		data() {
			return {

			}
		},
		methods: {
			back_home: function() {
				this.$router.replace("/")
			}
		}

	}
</script>

<style scoped="scoped">
	.error_page {
		/* position: relative;
		background-size: cover;
		background-position: 0 0;
		position: relative;
		width: 100%; */
		width: 100%;
		position: relative;
		background-color: #000;
	}

	.error_page video {
		width: 100%;
		height: 100%;
		object-fit: fill;
		position: absolute;
	}

	.error_page_content {
		width: 1200px;
		margin: 0 auto;
		padding-top: 140px;
		position: relative;
	}

	.error_page_content p {
		height: 100px;
		line-height: 100px;
		margin-top: 30px;
		font-size: 100px;
		color: #fafafa;
		font-family: jura, sans-serif;
		font-weight: 400;
		text-indent:150px;
	}
	.error_page_content p:nth-child(2){
		text-indent:160px;
	}

	.error_page_content p span {
		color: #FF2828;
	}

	.back_btn {
		height: 30px;
		margin-top: 50px;
		background-color: unset;
		font-size: 12px;
		color: #FAFAFA;
		border: 1px #FAFAFA solid;
		padding: 4px 30px;
		margin-left: 345px;
		margin-bottom:200px;
	}

	.back_btn:hover {
		background-color: #fff;
		color: #000;
	}
</style>



// WEBPACK FOOTER //
// src/views/public/Error.vue